import { setSvgIconSize } from '@globals/themes/globalStyles'
import AttachFileRounded from '@mui/icons-material/AttachFileRounded'
import Button from '@mui/material/Button'
import { SxProps } from '@mui/material/styles'
import { T, useT } from '@transifex/react'

type AddAttachmentButtonProps = {
  buttonId: string
  onClick: () => void
  disabled?: boolean
  ariaLabelledBy?: string
  showLabel?: boolean
  buttonStyles?: SxProps
}

const AddAttachmentButton: React.FC<AddAttachmentButtonProps> = ({
  buttonId,
  onClick,
  ariaLabelledBy,
  disabled = false,
  showLabel = true,
  buttonStyles = {
    ...setSvgIconSize('1.5rem'),
    mt: 2,
  },
}) => {
  const t = useT()

  return (
    <Button
      id={buttonId}
      aria-label={t('Add attachment button')}
      sx={buttonStyles}
      onClick={onClick}
      variant="text"
      disabled={disabled}
      aria-labelledby={ariaLabelledBy}
      startIcon={<AttachFileRounded />}>
      {showLabel && <T _str="Add attachment" />}
    </Button>
  )
}

export default AddAttachmentButton
